import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PhoneMessages as messages } from './Phone.i18n';
import { formatPhoneNumber } from '../../shared/stringUtilities';

export const PhoneType = {
  DEFAULT: 0,
  HOME: 1,
  FAX: 2,
  MOBILE: 3,
  WORK: 4,
};

export class Phone extends React.Component {
  renderPhone(phoneType, phone) {
    if (phone && phone !== '') {
      let formattedMessageKey;
      switch (phoneType) {
        case PhoneType.HOME:
          formattedMessageKey = 'home';
          break;
        case PhoneType.FAX:
          formattedMessageKey = 'fax';
          break;
        case PhoneType.MOBILE:
          formattedMessageKey = 'cell';
          break;
        case PhoneType.WORK:
          formattedMessageKey = 'work';
          break;
        default:
          formattedMessageKey = 'default';
      }

      return (
        <div {...this.props.otherProperties} data-qa-item={formattedMessageKey + "Number"}  >
          <FormattedMessage {...messages.labels[formattedMessageKey]} />: {formatPhoneNumber(phone)}
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <div>
        {this.renderPhone(PhoneType.DEFAULT, this.props.phone) }
        {this.renderPhone(PhoneType.HOME, this.props.homePhone) }
        {this.renderPhone(PhoneType.MOBILE, this.props.mobilePhone) }
        {this.renderPhone(PhoneType.WORK, this.props.workPhone) }
        {this.renderPhone(PhoneType.FAX, this.props.fax) }
      </div>
    );
  }
}

Phone.propTypes = {
  phone: PropTypes.string,
  homePhone: PropTypes.string,
  mobilePhone: PropTypes.string,
  workPhone: PropTypes.string,
  fax: PropTypes.string,
  otherProperties: PropTypes.object,
};